import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import Input from "./Input";
import Input1xbet from "./Input1xbet";

function InputIndex(props) {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? <Input1xbet {...props} /> : <Input {...props} />;
}

export default InputIndex;
